import React from 'react';

const navigation = [
  {
    name: 'Email',
    href: 'mailto:elibolseda@gmail.com',
    icon: (props) => (
      <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2v.01L12 13 4 6.01V6h16zm0 12H4V8.99l8 6.99 8-6.99V18z" />
      </svg>
    ),
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/in/sedaelibol/',
    icon: (props) => (
      <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
        <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.27c-.966 0-1.75-.79-1.75-1.76 0-.97.784-1.76 1.75-1.76s1.75.79 1.75 1.76c0 .97-.784 1.76-1.75 1.76zm13.5 11.27h-3v-5.6c0-1.34-.03-3.07-1.87-3.07-1.87 0-2.16 1.46-2.16 2.97v5.7h-3v-10h2.89v1.36h.04c.4-.75 1.38-1.54 2.84-1.54 3.04 0 3.6 2 3.6 4.59v5.59z" />
      </svg>
    ),
  },
  {
    name: 'Substack',
    href: 'https://sedaelibol.substack.com/',
    icon: (props) => (
      <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M4 6h24v4H4V6zm0 6h24v4H4v-4zm0 6h24v10L16 20 4 28V18z" />
      </svg>
    ),
  },
];

const Footer = () => (
  <footer className="bg-background border-t">
    <div className="mx-auto max-w-7xl px-6 py-8 md:flex md:items-center md:justify-between lg:px-8">
      <div className="flex justify-center gap-x-6 md:order-2">
        {navigation.map((item) => (
          <a key={item.name} href={item.href} className="text-gray-600 hover:text-gray-800" target="_blank" rel="noopener noreferrer">
            <span className="sr-only">{item.name}</span>
            <item.icon aria-hidden="true" className="size-6" />
          </a>
        ))}
      </div>
      <p className="mt-8 text-center text-sm/6 text-gray-600 md:order-1 md:mt-0">
        &copy; {new Date().getFullYear()} Seda Elibol - lovingly crafted by <a href="https://zntemel.com" target="_blank" rel="noopener noreferrer" className="underline text-green-800 hover:text-gray-600">Zeynep Nur Temel</a>
      </p>
    </div>
  </footer>
);

export default Footer; 
